var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-3",attrs:{"title":"Audio"}},[_c('volume-slider',{model:{value:(_vm.settings.volume),callback:function ($$v) {_vm.$set(_vm.settings, "volume", $$v)},expression:"settings.volume"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }